<template>
  <div class="details">
    <home-header :isShow="true" activeIndex="3"></home-header>

    <div class="center_box">
      <img :src="activity_info.banner" class="banner" />
      <div class="title">
        {{ activity_info.title }}
      </div>
      <div class="time">
        {{ activity_info.start_time }}-{{ activity_info.end_time }}
      </div>
      <div class="btns">
        <!--  -->
        <button
          v-if="firstBtn.is_show == 1"
          style="background: #58B75B;cursor: pointer;"
          @click="workclick(activity_info.is_works)"
        >
          {{ firstBtn.title }}
          <!-- {{ rightBtnText }} -->
        </button>
        <!-- end -->
        <button
          v-if="secondBtn.is_show == 1"
          style="background: #FFB463;cursor: pointer;"
          @click="doClick"
        >
          {{ secondBtn.title }}
          <!-- {{ leftBtnText }} -->
        </button>
        <button
          v-if="thirdBtn.is_show == 1"
          style="background-color: #3370ff;cursor: pointer;"
          @click="fixedClick"
        >
          {{ thirdBtn.title }}
        </button>
      </div>
    </div>

    <div class="text_center">
      <comment-title :isShow="false" titleText="主办单位"></comment-title>
      <div class="text_list">
        <p v-if="activity_info.sponsor != '' ? true : false">
          {{ activity_info.type == 8 ? "" : "活动主办：" }}
          {{ activity_info.sponsor }}
        </p>
        <p v-if="activity_info.co_sponsor != '' ? true : false">
          {{ activity_info.type == 8 ? "" : "活动协办：" }}
          {{ activity_info.co_sponsor }}
        </p>
        <p v-if="activity_info.organizer != '' ? true : false">
          {{ activity_info.type == 8 ? "" : "活动承办：" }}
          {{ activity_info.organizer }}
        </p>
        <p v-if="activity_info.support != '' ? true : false">
          {{ activity_info.type == 8 ? "" : "平台支持：" }}
          {{ activity_info.support }}
        </p>
      </div>
    </div>

    <div class="text_center">
      <comment-title :isShow="false" titleText="活动详情"></comment-title>
      <div class="text_list" v-html="activity_info.content"></div>
    </div>

    <home-footer></home-footer>

    <!--  -->
    <el-dialog title="" :visible.sync="dialogTableVisible">
      <div class="dialog-con">
        <div v-html="richText" class="content"></div>
        <div class="footer-box">
          <el-button
            style="background-color: #3370ff;color: #fff;"
            @click="navTo"
            >我知道</el-button
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import HomeHeader from "@/components/homeHeader";
import HomeFooter from "@/components/Footer";
import CommentTitle from "@/components/Title";

import { ACTIVITY_TYPE, ACTIVITY_STATUS } from "../constant/index.js";

const IS_KNOW = "is-know";

import { fetchSignUp } from "@/request/api_index.js";
import { showErrMsg, showMsg, formatRichtextImg } from "../utils/tool";
import { USER } from "../constant/storage";

export default {
  name: "Details",
  components: {
    HomeHeader,
    HomeFooter,
    CommentTitle
  },
  data() {
    return {
      activity_info: "",
      dialogTableVisible: false,
      richText: "",
      btnText: "",
      firstBtn: {
        is_show: 0
      },
      secondBtn: {
        is_show: 0
      },
      thirdBtn: {
        is_show: 0
      }
    };
  },
  created: function() {
    this.getDetail();
    this.getRichText();

    this.dialogTableVisible = false;

    this.getQuery();
  },
  watch: {
    //监测路由变化，只要变化了就调用路由参数方法将数据存储本组件即可
    $route: "getDetail"
  },
  computed: {
    isShowAnswer() {
      if (this.activity_info.type == undefined) {
        return false;
      } else {
        if (this.activity_info.type == ACTIVITY_TYPE.topic) {
          return false;
        } else {
          return true;
        }
      }
    },
    // 显示参赛作品
    isShowWorks() {
      let result = false;
      let list = [
        ACTIVITY_TYPE.clock,
        ACTIVITY_TYPE.riddles,
        ACTIVITY_TYPE.vote
      ];
      if (list.includes(+this.activity_info.type)) {
        result = false;
      } else {
        if (this.activity_info.is_works == 1) {
          result = true;
        } else {
          result = false;
          if (this.activity_info.activity_config) {
            let config = JSON.parse(
              this.activity_info.activity_config.button_1
            );
            result = config.is_show == 1 ? true : false;
          }
        }
      }
      return result;
    },
    // 参赛作品按钮的样式
    joinWorkStyle() {
      let style = ``;
      let styleWay = {
        0: "background:#ececec;color:#777474",
        1: "background: #FFB463;"
      };
      return styleWay[this.activity_info.is_works];
    },
    leftBtnText() {
      /**
       * 是否需要报名
       *
       */
      let result = "";
      const activity = this.activity_info;

      const NEED_SIGN = {
        need: 1,
        not: 0
      };
      const setTextBySign = text => {
        result = text;
      };
      const needRules = {
        [NEED_SIGN.need]: () => {
          const handle = () => {
            if (activity.activity_config) {
              //
              // let btn1Config = JSON.parse(activity.activity_config.button_2);
              let btn1Config = this.adapterBtnData(
                activity.activity_config.button_2
              );
              setTextBySign(btn1Config.title);
            } else {
              setTextBySign("我要参赛");
            }
          };
          activity.is_sign && handle();
          activity.is_sign == false && setTextBySign("我要报名");
        },
        [NEED_SIGN.not]: () => {
          if (ACTIVITY_TYPE.clock == +this.activity_info.type) {
            if (+this.activity_info.status == ACTIVITY_STATUS.end) {
              setTextBySign("查看阅读");
            } else {
              setTextBySign("我要打卡");
            }
          } else {
            if (activity.activity_config) {
              // let btn1Config = JSON.parse(activity.activity_config.button_2);
              let btn1Config = this.adapterBtnData(
                activity.activity_config.button_2
              );
              setTextBySign(btn1Config.title);
            } else {
              setTextBySign("我要参赛");
            }
          }
        }
      };
      if (activity) {
        needRules[this.activity_info.is_need_sign]();
      }
      return result;
    },
    rightBtnText() {
      let result = "";
      if (this.activity_info.activity_config) {
        // let btn2Config = JSON.parse(
        //   this.activity_info.activity_config.button_1
        // );
        let btn2Config = this.adapterBtnData(
          this.activity_info.activity_config.button_1
        );
        result = btn2Config.title;
      } else {
        result = "参赛作品";
      }
      return result;
    },
    //悬浮按钮
    fixedBtn() {
      let result = {
        isShow: false
      };
      if (this.activity_info.activity_config) {
        if (this.activity_info.activity_config.button_3) {
          // let data = JSON.parse(this.activity_info.activity_config.button_3);
          let data = this.adapterBtnData(
            this.activity_info.activity_config.button_3
          );
          result.isShow = true;
          result = {
            ...result,
            ...data
          };
        }
      }
      return result;
    }
  },
  methods: {
    navTo() {
      // localStorage.setItem(IS_KNOW, true);
      // let id = this.$route.params.id;
      // this.dialogTableVisible = false;

      // this.$router.push("/upload_426/" + id);

      this.dialogTableVisible = false;
    },
    async getRichText() {
      try {
        let data = await this.$api.fetchRichText({
          data: {
            type: "zky"
          }
        });
        console.log("富文本", data);
        if (data.data == null) {
          this.richText = "";
          localStorage.setItem(IS_KNOW, false);
        } else {
          this.richText = data.data.mes;
        }
      } catch (err) {
        console.error("err", err);
      }
    },
    // 是否提交过打卡信息
    async isaddClockActivity() {
      try {
        let data = {
          params: {
            "access-token": localStorage.getItem("token")
          },
          data: {
            activity_id: this.activity_info.id
          }
        };
        let res = await this.$api.isaddClock(data);
        console.log("bbb", res);
        return res.data;
      } catch (e) {
        console.log("err", e);
        if (e.code === 422) {
          return Promise.resolve(e);
        } else {
          return Promise.reject(e);
        }
      }
    },
    // 加入打卡活动
    joinclock(id) {
        if(!id){
            id = this.activity_info.id ;
        }
        if(id == 1470){
            this.$router.push("/upload/1471");
            return;
        }
      this.isaddClockActivity()
        .then(res => {
          console.log("is_submit", res);
          console.log("是否加入过", this.activity_info.status);
          // res.is_submit = 0;
          this.$message.closeAll();
          let status = {
            [ACTIVITY_STATUS.not_start]: () => {
              //
              this.$message({
                // showClose: true,
                type: "warning",
                message: "活动未开始"
              });
            },
            [ACTIVITY_STATUS.underway]: () => {

              if (res.is_submit == 1) {
                this.$router.push({
                  path: "/clockin/rank",
                  query: {
                    id: this.activity_info.id,
                    status: this.activity_info.status
                  }
                });
              } else {
                this.$router.push({
                  path: "/clocksubmit",
                  query: {
                    id: this.activity_info.id
                  }
                });
              }
            },
            [ACTIVITY_STATUS.end]: () => {
              //
              this.$message({
                // showClose: true,
                type: "warning",
                message: "活动已结束"
              });
            }
          };
           status[this.activity_info.status]();
          return;
          if (res.is_submit == 1) {
            this.$router.push({
              path: "/clockin/rank",
              query: {
                id: this.activity_info.id,
                status: this.activity_info.status
              }
            });
          } else {
            this.$router.push({
              path: "/clocksubmit",
              query: {
                id: this.activity_info.id
              }
            });
          }
        })
        .catch(err => {});
      // return ;
    },
    joinclick() {
      const TYPE = {
        answer: 8
      };
      let id = this.$route.params.id;
      if (this.activity_info.type == 6) {
        this.$message.closeAll();
        this.$message("请在小程序端参与活动");
      } else if (this.activity_info.type == TYPE.answer) {
        // this.$router.push("/upload/" + id);
        let { is_delete } = this.activity_info;
        // console.log('is_delete', is_delete)

        // return;
        this.$router.push({
          path: "/answer-activity",
          query: {
            activityId: this.activity_info.id,
            is_delete: is_delete
          }
        });
      } else if (this.activity_info.type == 11) {
        //
        this.$message.closeAll();
        this.$message("请在小程序端参与活动");
      } else {
        localStorage.setItem("activity-type", this.activity_info.type);
        // this.$router.push("/upload/" + id);

        if (+id === 426) {
          if (localStorage.getItem(IS_KNOW)) {
            this.$router.push("/upload_426/" + id);
          } else {
            this.dialogTableVisible = true;
          }
        } else if (+id === 1001) {
          //
          this.$router.push("/custom-upload/" + id);
        } else if (+id === 1470){
            console.log("活动id", id == 1470);
          this.$router.push("/upload/1471");
        }else {
          this.$router.push("/upload/" + id);
        }
      }
    },
    overclick() {
      this.$message.closeAll();
      this.$message("活动已结束");
    },
    beginclick() {
      this.$message.closeAll();
      this.$message("活动未开始");
    },
    workclick(is_works) {
        if( this.activity_info.id== 1470){
            this.joinclock(1471);
            return;
        }
      if (is_works == 0) {
        this.$message.closeAll();
        this.$message("作品暂未开放!");
        return;
      }
      let id = this.$route.params.id;
      this.$router.push("/works/" + id);
    },

    getDetail() {
      let id = this.$route.params.id;
      this.$api
        .activityDetail({ id: id })
        .then(res => {
          //数据处理
          // res.data.status = 4;//mock
          this.$data.activity_info = res.data;
          // this.data.activity_info.status = 4;
          this.setBtns(res.data);
          // this.$router.push({
          //   path: '/detail-richtext/' + id
          // })
        })
        .catch(err => console.log(err));
    },

    getQuery() {
      let query = this.$route.query;
      console.log("机构==================", query);
      if (query.ogran) {
        localStorage.setItem("ogran_id", query.ogran);
      }
    },

    setBtnTextAndStyle() {
      //
    },

    // 报名
    async signUp() {
      try {
        const res = await fetchSignUp({
          data: {
            activity_id: this.$route.params.id
          }
        });
        this.$message.closeAll();
        this.$message({
          showClose: true,
          message: "报名成功",
          type: "success"
        });
        this.getDetail();
        return res;
      } catch (error) {
        showErrMsg(error);
        return Promise.reject(error);
      }
    },
    doClick() {
      //
      console.log("signup", this.$route.params.id);
      console.log("活动类型", this.activity_info.type);
      if (this.activity_info.type == ACTIVITY_TYPE.vote) {
        // 投票类型
        this.$message.closeAll();
        this.$message({
          showClose: true,
          message: "当前活动pc端暂不支持",
          type: "info"
        });
        return;
      }

      const NEED_SIGN = {
        need: 1,
        no: 0
      };

      //
      const STATUSRULES = {
        [ACTIVITY_STATUS.not_start]: () => {
          showMsg({
            message: "活动未开始",
            type: "info"
          });
        },
        [ACTIVITY_STATUS.underway]: () => {
          const arr = [
            ACTIVITY_TYPE.audio,
            ACTIVITY_TYPE.image,
            ACTIVITY_TYPE.text,
            ACTIVITY_TYPE.video,
            ACTIVITY_TYPE.video_audio,
            ACTIVITY_TYPE.riddles,
            ACTIVITY_TYPE.vote,
            ACTIVITY_TYPE.submit
          ];
          if (arr.includes(+this.activity_info.type)) {
            //
            this.joinclick();
          } else if (+this.activity_info.type == ACTIVITY_TYPE.clock) {
            this.joinclock();
          }

          // 线下报名
          if (this.activity_info.type == 12) {
            this.$message.closeAll();
            this.$message({
              message: "请在手机端参加线下活动",
              type: "warning"
            });
          }
        },
        [ACTIVITY_STATUS.end]: () => {
          if (this.activity_info.type == ACTIVITY_TYPE.clock) {
            this.joinclock();
          } else {
            showMsg({
              message: "活动已结束",
              type: "info"
            });
          }
        }
      };
      let user = JSON.parse(localStorage.getItem(USER));
      // user.is_complete = 0;
      if (!user) {
        this.$router.push({
          path: "/login",
          query: {
            redirect: this.$route.fullPath
          }
        });
      }
      STATUSRULES[this.activity_info.status]();

      // if (user.is_complete == 1) {
      //   STATUSRULES[this.activity_info.status]();
      // } else {
      //   this.$alert("请先编辑个人资料", "提示", {
      //     confirmButtonText: "确定",
      //     callback: action => {
      //       if (action == "confirm") {
      //         console.log("ccc", this.$route.fullPath);
      //         this.$router.push({
      //           path: "/mine/userinfo",
      //           query: {
      //             redirect: this.$router.currentRoute.fullPath
      //           }
      //         });
      //       }
      //       // this.$message({
      //       //   type: "info",
      //       //   message: `action: ${action}`
      //       // });
      //     }
      //   });
      // }
    },
    // 悬浮按钮
    fixedClick() {
        if( this.activity_info.id== 1470){
            let id = this.$route.params.id;
            this.$router.push("/works/1471");
            return;
        }
      const TYPES = {
        url: 1,
        richtext: 2,
        book: 3
      };
      const rules = {
        [TYPES.url]: () => {
            if(this.activity_info.id == 1385){
                this.$alert("<span style='font-size: 20px'>请于手机端扫码查看</span><br><img style='padding:20px 0 10px' width='250' height='250' src='https://www.yulin365.net/attachment/images/topic/booklist.png' alt=''>", "", {
                    center: true,
                    showConfirmButton: false,
                    dangerouslyUseHTMLString: true,
                    callback: action => {
                    }
                });
            }else{
                this.openTab(this.activity_info.activity_config.link);
            }
        },
        [TYPES.richtext]: () => {
          // this.richText = formatRichtextImg(
          //   this.activity_info.activity_config.content
          // );
          // this.dialogTableVisible = true;
          this.$router.push({
            path: "/detail-richtext/" + this.$route.params.id,
          });
        },
        [TYPES.book]: () => {
          //
          this.$router.push({
            path: "/book-list" + `/${this.$route.params.id}`
          });
        }
      };
      rules[this.thirdBtn.type]();
    },
    /**
     * 新窗口打开
     * @param {*} url
     */
    openTab(url = "") {
      let link = document.createElement("a");
      link.href = url;
      link.setAttribute("target", "_blank");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    //
    adapterBtnData(value) {
      if (typeof value == "string") {
        let data = JSON.parse(value);
        if (Array.isArray(data)) {
          return data[0];
        } else {
          return data;
        }
      } else {
        if (Array.isArray(value)) {
          return value[0];
        } else {
          return value;
        }
      }
    },
    //
    /**
     * 设置按钮显示
     * @param {*} data
     */
    setBtns(data) {
      console.clear();
      console.log("活动类型", data.type);
      console.log("dd", data);

      // data.activity_config = null;
      let config = data.activity_config;
      if (config) {
        if (config.button_1) {
          this.firstBtn = this.adapterBtnData(config.button_1);
        }
        if (config.button_2) {
          this.secondBtn = this.adapterBtnData(config.button_2);
        }
        if (config.button_3) {
          this.thirdBtn = this.adapterBtnData(config.button_3);
        }
      } else {
        // config == null 默认配置
        let arr = [
          ACTIVITY_TYPE.clock,
          ACTIVITY_TYPE.topic,
          ACTIVITY_TYPE.submit
        ];
        if (arr.includes(data.type)) {
          // 特殊处理的活动类型 打开类、答题类、提交类
          let rules = {
            [ACTIVITY_TYPE.submit]: () => {
              // 推荐列表 我要推荐
              this.firstBtn = {
                is_show: 1,
                title: "我要推荐"
              };
              this.secondBtn = {
                is_show: 1,
                title: "推荐列表"
              };
            },
            [ACTIVITY_TYPE.clock]: () => {
              this.secondBtn = {
                is_show: 1,
                title: "我要参赛"
              };
            },
            [ACTIVITY_TYPE.topic]: () => {
              this.firstBtn = {
                is_show: 1,
                title: "答题排行榜"
              };
              this.secondBtn = {
                is_show: 1,
                title: "我要参赛"
              };
            }
          };
          rules[data.type]();
        } else {
          //
          this.firstBtn = {
            is_show: 1,
            title: "作品列表"
          };
          this.secondBtn = {
            is_show: 1,
            title: "上传作品"
          };
        }
      }
      // 线下报名活动单独处理
      if (data.type == 12) {
        this.secondBtn.title = "活动报名";
        this.firstBtn.is_show = 0;
      }
    }
  }
};
</script>

<style scoped>
.details {
  background: #f3f3f3;
}

.center_box {
  width: 1200px;
  margin: 20px auto;
  background: #ffffff;
  border-radius: 10px;
}

.banner {
  width: 1200px;
  height: 440px;
  background: #3370ff;
  border-radius: 10px 10px 0px 0px;
}

.center_box .title {
  height: 20px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #333333;
  margin: 20px;
}

.time {
  height: 13px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
  margin: 0px 20px;
}

.btns {
  margin: 20px;
}

button {
  background: #58b75b;
  border-radius: 10px;
  border: none;
  margin: 20px;
  text-align: center;
  color: #fff;
}

.text_center {
  width: 1200px;
  background: #ffffff;
  border-radius: 10px;
  margin: 20px auto;
  padding: 20px 0px;
}

.text_list {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 30px;
  color: #333333;
  margin-left: 62px;
  margin-top: 20px;
  padding-right: 50px;
  box-sizing: border-box;
}

.text_list >>> img {
  width: 100% !important;
  margin: 0 auto !important;
}

@media (min-width: 1024px) {
  button {
    width: 150px;
    height: 50px;
  }
}

/*>=1024的设备*/

@media (min-width: 1280px) {
  button {
    width: 120px;
    height: 40px;
  }
}

/*>=1280的设备*/

.footer-box {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 80px;
  font-size: 30px;
}
</style>



// WEBPACK FOOTER //
// src/details/Details.vue